export default __webpack_public_path__ + "static/media/warning--dead-end--g1.822dc654.png";